const ControlDataTypeKey = "@@makeswift/type";
export {
  ControlDataTypeKey
};
//# sourceMappingURL=control-data-type-key.js.map